import React, { useEffect, useState } from "react";
import { TreeSelect } from "antd";
import { useDispatch } from "react-redux";
// import { setSelectedLocation } from "@/redux/slices/locationsLice.ts";
import "./locations.scss";
import { setSelectedLocationThunk } from "../../../redux/slices/locationsSlice";

export default function Locations({
  locations,
  handleClickSelect,
  defaultValue = false,
  aditionalStyle = {},
  cleanable = false,
}) {
  const dispatch = useDispatch();
  let datas = [];
  let dataSelect = 0;
  let itemDisable = [];

  function childChild(childrenLocation) {
    let childrenArray = [];
    childrenLocation.map((child) => {
      if (!child.canShowLocation) {
        itemDisable.push(child.locationId);
      }
      if (child.defaultSelected) {
        dataSelect = child.locationId;
        localStorage.setItem("Location", dataSelect);
        dispatch(setSelectedLocationThunk(dataSelect));
        if (defaultValue) handleClickSelect(dataSelect);
      }
      childrenArray.push({
        title: child.locationName,
        value: child.locationId,
        disabled: !child.canShowLocation,
        ...(child.hasChild
          ? { children: childChild(child.childLocations) }
          : {}),
      });
    });

    return childrenArray;
  }

  if (locations && locations.length > 0) {
    datas = locations.map((location) => {
      if (!location.canShowLocation) {
        itemDisable.push(location.locationId);
      }
      return {
        title: location.locationName,
        value: location.locationId,
        disabled: !location.canShowLocation,
        ...(location.hasChild
          ? { children: childChild(location.childLocations) }
          : {}),
      };
    });
    const index = locations.findIndex((location) => location.defaultSelected);

    if (index >= 0) {
      dataSelect = locations[index].locationId;
    }
  } else {
    datas = [];
  }

  useEffect(() => {
    if (locations && locations.length > 0) {
      locations.forEach((location) => {
        if (location.defaultSelected) {
          localStorage.setItem("Location", location.locationId);
          dispatch(setSelectedLocationThunk(location.locationId));
          if (defaultValue) handleClickSelect(dataSelect);
        }
        if (location.childLocations != null) {
          location.childLocations.forEach((l) => {
            if (l.defaultSelected) {
              localStorage.setItem("Location", l.locationId);
              dispatch(setSelectedLocationThunk(l.locationId));
              if (defaultValue) handleClickSelect(dataSelect);
            }
          });
        }
      });
    }
  }, [locations]);

  return (
    <>
      {datas.length > 0 ? (
        <TreeSelect
          treeData={datas}
          showSearch
          onChange={handleClickSelect}
          treeDefaultExpandAll
          defaultValue={defaultValue ? dataSelect : undefined}
          allowClear={cleanable}
          className="location-picker"
          style={{ ...aditionalStyle }}
          placeholder="Select Location"
        />
      ) : (
        ""
      )}
    </>
  );
}
